export function About() {
  return (
    <div class="max-w-md mx-auto px-4 py-6 space-y-6">
      <h1 class="text-xl font-bold text-hudson-navy">About</h1>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-hudson-navy">
          Built for Canadians who verify their numbers
        </h2>
        <p class="text-sm text-body/80 leading-relaxed">
          Hudson Bay Finance makes free, audit-grade Canadian tax tools.
          Every calculation in this app is hash-verified, formula-certified,
          audit-grade — checked against CRA's published rules covering
          contribution room by birth year and residency, the withdrawal
          restoration timing rule, and over-contribution detection. Every
          number is accurate to the cent.
        </p>
        <p class="text-sm text-body/80 leading-relaxed">
          Canadian tax tools are usually either expensive or wrong. Hudson
          Bay Finance exists because there's room for one that's neither —
          free, plain-English, and showable to a CPA without embarrassment.
        </p>
        <p class="text-sm text-body/80 leading-relaxed">
          Your data lives on this device only. There is no server. Hudson
          Bay Finance cannot see your numbers and cannot recover lost data.
          Export your data regularly from Settings.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">Founded by Mo</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          Hudson Bay Finance was founded by Mo — a Calgary-based Canadian
          retail investor and YouTube creator. Mo is not a CPA. He built the
          first version of this tool for his own use, then shipped it
          publicly because Canadians deserve better free tools.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">Full disclaimer</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          <strong>Hudson Bay Finance is not a CPA or financial advisor.</strong>{' '}
          This tool is for educational purposes only and does not constitute
          tax advice. Always verify your contribution room directly with CRA
          at{' '}
          <a
            href="https://www.canada.ca/en/revenue-agency/services/e-services/digital-services-individuals/account-individuals.html"
            class="text-hudson-navy underline focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
            target="_blank"
            rel="noopener noreferrer"
          >
            My CRA Account
          </a>{' '}
          before making contributions. Results in this app are estimates
          only.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">Show your work</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          Every TFSA calculation in this app is checked against CRA's
          published rules — contribution room by birth year and residency,
          the withdrawal restoration timing rule, residency eligibility,
          and the edge cases that trip up most tools. Numbers are accurate
          to the exact cent. If something looks wrong, email us — we'll
          fix it the day we see it.
        </p>
      </section>

      <section class="space-y-2 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">Contact</h2>
        <p class="text-sm text-body/80">
          Questions or corrections:{' '}
          <a
            href="mailto:hbfproducts1@gmail.com"
            class="text-hudson-navy underline focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
          >
            hbfproducts1@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
}
